import React from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import Text from 'components/Text';
import { formatPrice } from 'utils/format';
import './index.sass';

const { block, el } = bem('payment-card-summary');
const Summary = ({ price }) => {

    return (
        <div className={ block() }>
            <div className={ el('details-costs', 'total') }>
                <Text className={ el('details-label') }>
                    Итого к оплате
                </Text>
                <Text className={ el('details-value') }>
                    { formatPrice(price) }
                </Text>
            </div>
        </div>
    )
};

export default observer(Summary);
